import { Layout as BaseLayout, LayoutProps } from 'react-admin';
import appBar from './appBar';
import Menu from './Menu';
import theme from './theme';

export default function Layout(props: LayoutProps) {
  return <BaseLayout {...props} appBar={appBar} menu={Menu} theme={theme} />;
}
